import React from 'react';
import { Shield } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-brand-50">
        <div className="max-w-4xl mx-auto text-center">
          <Shield className="w-16 h-16 text-brand-900 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold text-brand-900 mb-4">
            Datenschutzerklärung
          </h1>
          <p className="text-lg text-brand-700">
            Informationen zum Schutz Ihrer personenbezogenen Daten
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto prose prose-lg">
          
          {/* Allgemeine Hinweise */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Allgemeine Hinweise</h2>
            <p className="text-brand-700 leading-relaxed">
              Die Nutzung dieser Website ist in der Regel ohne Angabe personenbezogener Daten möglich.
            </p>
          </div>

          {/* Verantwortlicher */}
          <div className="mb-12 p-6 bg-brand-50 rounded-xl">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Verantwortlicher</h2>
            <div className="text-brand-700 leading-relaxed">
              <p className="font-semibold text-brand-900">Dr. Hans-Dieter Graßl</p>
              <p>Bahnhofstraße 8</p>
              <p>26336 Varel</p>
              <p>Deutschland</p>
              <p className="mt-2">
                E-Mail: <a href="mailto:hdgdr@icloud.com" className="text-brand-800 hover:text-brand-900 underline">hdgdr@icloud.com</a>
              </p>
            </div>
          </div>

          {/* Hosting & Server-Logfiles */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Hosting & Server-Logfiles</h2>
            <p className="text-brand-700 leading-relaxed mb-4">
              Diese Website wird bei der <strong>STRATO AG</strong>, Otto-Ostrowski-Straße 7, 10249 Berlin gehostet. 
              Wir haben mit dem Anbieter einen Vertrag über Auftragsverarbeitung (AVV) geschlossen.
            </p>
            <p className="text-brand-700 leading-relaxed mb-3">
              Beim Besuch der Website werden technisch notwendige Daten verarbeitet:
            </p>
            <ul className="list-disc list-inside text-brand-700 leading-relaxed mb-4 space-y-2">
              <li>IP-Adresse</li>
              <li>Zeitpunkt des Zugriffs</li>
              <li>Browserinformationen</li>
            </ul>
            <p className="text-brand-700 leading-relaxed mb-3">
              Dies erfolgt zur Sicherstellung eines störungsfreien Betriebs.
            </p>
            <p className="text-brand-700 leading-relaxed">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO. Die Server-Logfiles werden nach den 
              gesetzlichen Vorgaben (in der Regel nach 7 Tagen) automatisch gelöscht.
            </p>
          </div>

          {/* Kontakt per E-Mail */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Kontakt per E-Mail</h2>
            <p className="text-brand-700 leading-relaxed mb-3">
              Bei Kontaktaufnahme öffnet sich lediglich Ihr E-Mail-Programm. Die Daten aus Ihrer E-Mail werden 
              zum Zweck der Bearbeitung Ihrer Anfrage gespeichert.
            </p>
            <p className="text-brand-700 leading-relaxed mb-3">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse) oder 
              Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung).
            </p>
            <p className="text-brand-700 leading-relaxed">
              Die Daten werden gelöscht, sobald Ihre Anfrage abschließend bearbeitet wurde und keine gesetzlichen 
              Aufbewahrungspflichten entgegenstehen.
            </p>
          </div>

          {/* Cookies */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Cookies</h2>
            <p className="text-brand-700 leading-relaxed">
              Es werden ausschließlich technisch notwendige Funktionen (Session-Cookies) verwendet.
            </p>
          </div>

          {/* Keine Analyse-Tools */}
          <div className="mb-12 p-6 bg-green-50 border-l-4 border-green-500 rounded-r-xl">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Keine Analyse-Tools</h2>
            <p className="text-brand-700 leading-relaxed">
              Es erfolgt <strong>keine Nutzung</strong> von Tracking- oder Analyse-Tools.
            </p>
          </div>

          {/* Rechte der betroffenen Personen */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Rechte der betroffenen Personen</h2>
            <p className="text-brand-700 leading-relaxed mb-3">
              Sie haben folgende Rechte:
            </p>
            <ul className="list-disc list-inside text-brand-700 leading-relaxed space-y-2">
              <li>Recht auf Auskunft über die Sie betreffenden personenbezogenen Daten</li>
              <li>Recht auf Berichtigung unrichtiger Daten</li>
              <li>Recht auf Löschung Ihrer Daten</li>
              <li>Recht auf Einschränkung der Verarbeitung</li>
              <li>Recht auf Datenübertragbarkeit</li>
              <li>Widerspruchsrecht gegen die Verarbeitung</li>
            </ul>
          </div>

          {/* Beschwerderecht */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Beschwerderecht</h2>
            <p className="text-brand-700 leading-relaxed">
              Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung Ihrer 
              personenbezogenen Daten durch uns zu beschweren.
            </p>
          </div>

          {/* Verschlüsselung */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Verschlüsselung</h2>
            <p className="text-brand-700 leading-relaxed">
              Diese Website nutzt eine sichere SSL/TLS-Verschlüsselung zum Schutz der Übertragung 
              vertraulicher Inhalte.
            </p>
          </div>

          {/* Stand */}
          <div className="pt-8 border-t border-brand-200">
            <p className="text-sm text-brand-600">
              Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long' })}
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Datenschutz;
